import React from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  Button,
  Input,
  InputLabel,
} from '@mui/material';
import PropTypes from 'prop-types';
import useStyles from './styles';

export default function Upload({ importFromFile, destination }) {
  const classes = useStyles();

  const handleFileSelect = (event) => {
    importFromFile(event.target.files[0], destination);
  };

  return (
    <form>
      <InputLabel>
        <Input
          className={classes.importerInput}
          type="file"
          multiple
          accept=".csv"
          onChange={(event) => handleFileSelect(event)}
        />
        <Button
          startIcon={<CloudUploadIcon fontSize="large" />}
          type="file"
          variant="contained"
          color="secondary"
          component="span"
          className={classes.button}
        >
          {destination}
        </Button>
      </InputLabel>
    </form>
  );
}

Upload.propTypes = {
  destination: PropTypes.string.isRequired,
  importFromFile: PropTypes.func.isRequired,
};
